import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../Automation/queryKeys';

export function useAutomationTemplateStepNoActionCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.INoActionAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			templateId,
			step,
			beforeId,
			impersonationContext,
		}: {
			templateId: string;
			step: Api.INoActionAutomationStep;
			beforeId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.INoActionAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/NoAction`,
					queryParams: beforeId ? { beforeId } : undefined,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data);
		},
	});
}
